import { useState, useEffect } from 'react';
import api from './api';
import { useAuth } from './AuthContext';

export function Gigs() {
    const [gigs, setGigs] = useState([]);
    const [title, setTitle] = useState('');
    const [venue, setVenue] = useState('');
    const [gigDate, setGigDate] = useState('');
    const [details, setDetails] = useState('');
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';

    const load = () => {
        api.get('/gigs').then((res) => setGigs(res.data));
    };

    useEffect(() => { load(); }, []);

    const addGig = async (e) => {
        e.preventDefault();
        if (!title) return;
        await api.post('/gigs', { title, venue, gig_date: gigDate, details });
        setTitle(''); setVenue(''); setGigDate(''); setDetails('');
        load();
    };

    const deleteGig = async (id) => {
        await api.delete(`/gigs/${id}`);
        load();
    };

    return (
        <div className="gigs-page">
            <h2>Gigs</h2>

            {isAdmin && (
                <form onSubmit={addGig} className="add-gig-form">
                    <input placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                    <input placeholder="Venue" value={venue} onChange={(e) => setVenue(e.target.value)} />
                    <input type="date" value={gigDate} onChange={(e) => setGigDate(e.target.value)} />
                    <input placeholder="Details" value={details} onChange={(e) => setDetails(e.target.value)} />
                    <button type="submit">Add Gig</button>
                </form>
            )}

            <div className="gigs-list">
                {gigs.map((gig) => (
                    <div key={gig.id} className="gig-item">
                        <h3>{gig.title}</h3>
                        <p>{gig.venue} — {gig.gig_date ? new Date(gig.gig_date).toLocaleDateString() : 'TBD'}</p>
                        {gig.details && <p>{gig.details}</p>}
                        {isAdmin && <button onClick={() => deleteGig(gig.id)}>Delete</button>}
                    </div>
                ))}
            </div>
        </div>
    );
}
